import React from 'react'

import { ClientProvider, Guillotina } from '@guillotinaweb/react-gmi'
import { getClient } from '../services/client'
import GuilloCfg from './config'

export function Guillo({ auth }) {
  const client = getClient(GuilloCfg.url, auth)
  return (
    <ClientProvider client={client}>
      <div className="guillotina">
        <Guillotina
          config={GuilloCfg.Cfg}
          url={GuilloCfg.url}
          registry={GuilloCfg.registry}
        />
      </div>
    </ClientProvider>
  )
}
